"use strict";

const FilterConstants = function () {
  const sbmpTypes = [
    "6", //Bed Filter
    "8", //Biofiltration
    "13", //Bioretention
    "15", //Bioswale
    "22", //Cistern
    "14", //Detention Basin
    "1", //Dry Basin
    "17", //Filtration Device
    "20", //Green Roof
    "3", //Infiltration Basin
    "9", //Infiltration Feature
    "5", //Media Filter
    "10", //Pervious Pavement
    "21", //Rain Barrel
    "19", //Retention Basin
    "11", //Sediment Trap
    "7", //Settling Basin
    "18", // Trash Trap
    "4", //Treatment Vault
    "2", //Wet Basin
    "16", //Unknown
    "null",
  ];

  const yesNoOptions = [
    {
      name: "Yes",
      value: true,
    },
    {
      name: "No",
      value: false,
    },
    {
      name: "No Data",
      value: "null",
    },
  ];
  const bmpTypeOptionsNoAbbreviationsScenarios = [
    {
      name: "Bed Filter",
      value: 6,
    },
    {
      name: "Biofiltration",
      value: 8,
    },
    {
      name: "Bioretention",
      value: 13,
    },
    {
      name: "Bioswale",
      value: 15,
    },
    {
      name: "Cistern",
      value: 22,
    },
    {
      name: "Detention Basin",
      value: 14,
    },

    {
      name: "Dry Basin",
      value: 1,
    },
    {
      name: "Filtration Device",
      value: 17,
    },
    {
      name: "Green Roof",
      value: 20,
    },
    {
      name: "Infiltration Basin",
      value: 3,
    },
    {
      name: "Infiltration Feature",
      value: 9,
    },
    {
      name: "Media Filter",
      value: 5,
    },
    {
      name: "Pervious Pavement",
      value: 10,
    },
    {
      name: "Rain Barrel",
      value: 21,
    },
    {
      name: "Retention Basin",
      value: 19,
    },
    {
      name: "Sediment Trap",
      value: 11,
    },
    {
      name: "Settling Basin",
      value: 7,
    },
    {
      name: "Treatment Vault",
      value: 4,
    },
    {
      name: "Wet Basin",
      value: 2,
    },
    {
      name: "Unknown",
      value: 16,
    },
    {
      name: "No Data",
      value: null,
    },
  ];

  const conditionOptions = [
    {
      name: "Issues",
      value: "poor",
    },
    {
      name: "No Issues",
      value: "optimal",
    },
    {
      name: "None",
      value: "null",
    },
  ];

  const getEnforcementLevel = function () {
    const maintenanceLevelsWithName = ToolSettings.getSetting("constants", "maintenanceLevels");
    const result = [];

    for (const key in maintenanceLevelsWithName) {
      result.push({
        name: maintenanceLevelsWithName[key].displayName,
        value: key,
      });
    }

    result.push(
      {
        name: "Unknown",
        value: "unknown",
      },
      {
        name: "No Data",
        value: "null",
      },
    );

    return result;
  };

  const initialFilters = {
    search: "",
    inaccessible: false,
    dateType: "assessment",
    dateTypeFcs: "assessment",
    dateTypeConstruction: "inspection",
    descend: false,
  };

  const spatialFilters = ["catchments", "receivingWaters", "maintenanceZones", "highways"];
  const filtersThatDisableDataSorts = [
    "catchmentName",
    "drainsToC",
    "drainsToRw",
    "highwayName",
    "drainsToSpatialGroupingId",
    "drainsToAssesmentArea",
    "subGroups",
    "zones",
  ];
  const dataSortsDisabledForSpatialSmartFilters = [
    "rw",
    "ud",
    "uc",
    "highways",
    "monitoringDrainages",
    "assessmentAreas",
    "watersheds",
    "maintenanceZones",
  ];
  const dataSortsEnabledForSpatialSmartFilters = ["assetManagementId"];

  const getDefaultFiltersByDataView = function (dataView = Tree.get("dataView")) {
    const normalizedDataView = dataView === "roads" ? "muni-catch-basin" : dataView;
    const filtersByDataView = getDefaultFilter(normalizedDataView);

    if (filtersByDataView === undefined) {
      console.warn(`No default filters provided for dataView ${dataView} in filterConstants`);
      return {};
    }

    return filtersByDataView;
  };

  var getDefaultFilter = function (dataView) {
    const constructionConditionPhaseToggle = "condition";

    const getMuniBmp = () => ({
      responsiblePartyMaintenance: ["our-agency", "unknown"],
      implementationPhase: ["completed", "certified"],
      types: sbmpTypes,
    });

    if (dataView === "bmp") {
      return {
        phase: ["completed", "certified"],
        types: sbmpTypes,
        conditionPhaseToggle: "condition",
      };
    } else if (dataView === "fcs") {
      return {
        phase: ["completed", "certified"],
        types: [
          "6",
          "8",
          "13",
          "15",
          "22",
          "14",
          "1",
          "17",
          "12",
          "20",
          "3",
          "9",
          "5",
          "10",
          "21",
          "19",
          "11",
          "7",
          "4",
          "2",
          "16",
          "18",
          "null",
        ],
      };
    } else if (dataView === "va") {
      return {
        assessmentDate: { from: DateTime.isoDateYearsAgo(2) },
      };
    } else if (dataView === "construction-project") {
      return {
        phase:
          constructionConditionPhaseToggle === "condition"
            ? ["construction", "post-active"]
            : ["planning", "planned", "construction", "post-active", "completed", "certified"],
        conditionPhaseToggle: constructionConditionPhaseToggle,
      };
    } else if (dataView === "construction-project-delivery") {
      return {
        phase: ToolSettings.getSetting("construction", "enable-post-active-phase")
          ? [
              "planning",
              "planned",
              "construction",
              "completed",
              "certified",
              "shelved",
              "rejected",
              "post-active",
            ]
          : ["planning", "planned", "construction", "completed", "certified", "shelved"],
        conditionPhaseToggle: "phase",
      };
    } else if (dataView === "lid-project") {
      return {
        status: ["completed", "certified"],
        dateTypeLidProject: "completed",
        conditionPhaseToggle: "condition",
      };
    } else if (dataView === "muni-manhole") {
      return {
        responsiblePartyMaintenance: ["our-agency", "unknown"],
        implementationPhase: ["completed", "certified"],
      };
    } else if (dataView === "lid-runoff") {
      return {
        status: ["completed", "certified"],
        dateTypeLidProject: "completed",
      };
    } else if (dataView === "muni-catch-basin") {
      return {
        phase: ["completed", "certified"],
        types: ["11", "12"],
        responsiblePartyMaintenance: ["our-agency", "unknown"],
        dateType: "install",
      };
    } else if (dataView === "muni-lift-stations") {
      return {
        phase: ["completed", "certified"],
        maintainedBy: ["our-agency", "unknown"],
      };
    } else if (dataView === "muni-cleanout") {
      return {
        phase: ["completed", "certified"],
        maintainedBy: ["our-agency", "unknown"],
      };
    } else if (dataView === "muni-pipes") {
      return {
        phase: ["completed", "certified"],
        maintainedBy: ["our-agency", "unknown"],
      };
    } else if (dataView === "muni-outfalls") {
      return {
        responsiblePartyMaintenance: ["our-agency", "unknown"],
        implementationPhase: ["completed", "certified"],
      };
    } else if (dataView === "muni-culvert") {
      return {
        responsiblePartyMaintenance: ["our-agency", "unknown"],
        implementationPhase: ["completed", "certified"],
      };
    } else if (dataView === "muni-open-channel") {
      return {
        responsiblePartyMaintenance: ["our-agency", "unknown"],
        implementationPhase: ["completed", "certified"],
      };
    } else if (dataView === "muni-bmp") {
      return getMuniBmp();
    } else if (dataView === "lid-bmp") {
      return {
        implementationPhase: ["completed", "certified"],
        types: sbmpTypes,
      };
    } else if (dataView === "incidents") {
      return {
        dateTypeIncidents: "requested",
      };
    } else if (dataView === "indcom-facilities") {
      return {
        conditionPhaseToggle: "condition",
        dateType: "inspection",
        facilityPhase: ["open"],
      };
    } else if (dataView === "scenarios") {
      return {
        conditionPhaseToggle: "phase",
        phase: ["planning", "planned", "construction", "post-active", "completed", "certified"],
        types: [
          "6",
          "8",
          "13",
          "15",
          "22",
          "14",
          "1",
          "17",
          "20",
          "3",
          "9",
          "5",
          "10",
          "21",
          "19",
          "11",
          "7",
          "4",
          "2",
          "16",
        ],
      };
    } else if (dataView === "dry-weather") {
      return {
        responsiblePartyMaintenance: ["our-agency", "unknown"],
        phase: ["completed", "certified"],
        isMonitoringLocation: ["true"],
      };
    } else if (dataView === "asset-management") {
      return {
        responsiblePartyMaintenance: ["our-agency"],
        phase: ["completed", "certified"],
      };
    }
  };

  var _getAllMaintenanceIssueOptionKeys = function () {
    return getAllCorrectiveOptions().map((option) => option.value);
  };

  const pipeTypeOptions = [
    { name: "Cattle Pass", value: "cattle pass" },
    { name: "Cross Drain", value: "cross drain" },
    { name: "Drain Tile", value: "drain tile" },
    { name: "Force Main-Pressurized", value: "force main" },
    { name: "Force Pipe", value: "force" },
    { name: "Gravity Main", value: "gravity" },
    { name: "Perforated Pipe", value: "perforated" },
    { name: "Underdrain", value: "underdrain" },
    { name: "Other", value: "other" },
    { name: "Unknown", value: "unknown" },
    { name: "No Data", value: "null" },
  ];

  const scenarioPhaseOptions = [
    {
      name: "Planning",
      value: "planning",
    },
    {
      name: "Design",
      value: "planned",
    },
    {
      name: "Completed",
      value: "completed",
    },
    {
      name: "Certified",
      value: "certified",
    },
    {
      name: "Construction",
      value: "construction",
    },
    {
      name: "Rejected",
      value: "rejected",
    },
    {
      name: "Shelved",
      value: "shelved",
    },
    {
      name: "No Data",
      value: "null",
    },
  ];

  const getAllCorrectiveOptions = function () {
    const maintenanceTasksWithName = ToolSettings.getSetting("constants", "maintenanceTasks");
    const result = [];

    for (const key in maintenanceTasksWithName) {
      result.push({
        name: maintenanceTasksWithName[key].displayName,
        value: key,
      });
    }

    result.push({ name: "No Corrective Actions", value: "no-action" });

    return result;
  };

  const openChannelType = [
    { name: "Aqueduct", value: "aqueduct" },
    { name: "Canal", value: "canal" },
    { name: "Ditch", value: "ditch" },
    { name: "Natural", value: "natural" },
    { name: "Other", value: "other" },
    { name: "Spillway", value: "spillway" },
    { name: "Unknown", value: "unknown" },
    { name: "No Data", value: "null" },
  ];

  const serviceType = [
    { name: "Combined Sewer-Storm", value: "combined" },
    { name: "Other", value: "other" },
    { name: "Recycled Water", value: "recycled" },
    { name: "Sewer", value: "sewer" },
    { name: "Storm", value: "storm" },
    { name: "Water Supply", value: "supply" },
    { name: "Unknown", value: "unknown" },
    { name: "No Data", value: "null" },
  ];

  const flowType = [
    { name: "Receiving Water", value: "receiving-water" },
    { name: "303(d) Impaired Waterbody", value: "303d" },
    { name: "Other", value: "other" },
    { name: "No Data", value: "null" },
  ];

  const linedAssetsShapes = [
    { name: "Circular", value: "circular" },
    { name: "Horseshoe", value: "horseshoe" },
    { name: "Irregular", value: "irregular" },
    { name: "Oblong", value: "oblong" },
    { name: "Other", value: "other" },
    { name: "Rectangular", value: "rectangular" },
    { name: "Trapezoidal", value: "trapezoidal" },
    { name: "Triangular", value: "triangular" },
    { name: "Unknown", value: "unknown" },
    { name: "No Data", value: "null" },
  ];

  const responsiblePartyOptions = [
    {
      name: "DOT",
      value: "dot",
    },
    {
      name: "Local Agency",
      value: "local-agency",
    },
    {
      name: "MS4",
      value: "ms4",
    },
    {
      name: "Other",
      value: "other",
    },
    {
      name: "Our Agency",
      value: "our-agency",
    },
    {
      name: "Partner",
      value: "partner",
    },
    {
      name: "Private",
      value: "private",
    },
    {
      name: "Unknown",
      value: "unknown",
    },
    {
      name: "No Data",
      value: "null",
    },
  ];

  const liftStationTypes = [
    { name: "Centrifugal Pump", value: "centrifugal" },
    { name: "Dry", value: "dry" },
    { name: "Duplex Pump", value: "duplex" },
    { name: "Jockey Pump", value: "jockey" },
    { name: "Simplex Pump", value: "simplex" },
    { name: "Split-case Lift", value: "split-case" },
    { name: "Submersible", value: "submersible" },
    { name: "Triplex Pump", value: "triplex" },
    { name: "Turbine Pump", value: "turbine" },
    { name: "Wet-dry Configuration", value: "wet-dry" },
    { name: "Other", value: "other" },
    { name: "Unknown", value: "unknown" },
    { name: "No Data", value: "null" },
  ];

  const cofOptionsWithNull = [
    { name: "Very High", value: "very-high" },
    { name: "High", value: "high" },
    { name: "Moderate", value: "moderate" },
    { name: "Low", value: "low" },
    { name: "Very Low", value: "very-low" },
    { name: "Unknown", value: "unknown" },
    { name: "No Data", value: "null" },
  ];

  const shapeOptions = [
    { name: "Archway", value: "archway" },
    { name: "Circular", value: "circular" },
    { name: "Egg Shaped", value: "egg-shaped" },
    { name: "Elliptical", value: "elliptical" },
    { name: "Horseshoe", value: "horseshoe" },
    { name: "Other", value: "other" },
    { name: "Rectangular", value: "rectangle" },
    { name: "Square", value: "square" },
    { name: "Trapezoid", value: "trapezoid" },
    { name: "Unknown", value: "unknown" },
    { name: "No Data", value: "null" },
  ];

  const outfallShapeOptions = [
    { name: "Archway", value: "archway" },
    { name: "Circular", value: "circular" },
    { name: "Egg Shaped", value: "egg-shaped" },
    { name: "Elliptical", value: "elliptical" },
    { name: "Horseshoe", value: "horseshoe" },
    { name: "Rectangular", value: "rectangle" },
    { name: "Square", value: "square" },
    { name: "Trapezoid", value: "trapezoid" },
    { name: "U-Shaped", value: "u-shaped" },
    { name: "Other", value: "other" },
    { name: "Unknown", value: "unknown" },
    { name: "No Data", value: "null" },
  ];

  const shapeOptionsCleanoutManholes = [
    { name: "Archway", value: "arched" },
    { name: "Circular", value: "circular" },
    { name: "Egg Shaped", value: "egg" },
    { name: "Elliptical", value: "oval" },
    { name: "Horseshoe", value: "horseshoe" },
    { name: "Other", value: "other" },
    { name: "Rectangular", value: "rectangular" },
    { name: "Square", value: "square" },
    { name: "Trapezoid", value: "trapezoid" },
    { name: "Unknown", value: "unknown" },
    { name: "No Data", value: "null" },
  ];
  const muniImplementationPhaseOptions = [
    { name: "Planning", value: "planning" },
    { name: "Design", value: "planned" },
    { name: "Construction", value: "construction" },
    { name: "Completed", value: "completed" },
    { name: "Certified", value: "certified" },
    { name: "Rejected", value: "rejected" },
    { name: "Shelved", value: "shelved" },
    { name: "Abandoned", value: "abandoned" },
    { name: "Removed", value: "removed" },
    { name: "Unknown", value: "unknown" },
    { name: "No Data", value: "null" },
  ];
  const cleanoutType = [
    { name: "Cleanout", value: "cleanout" },
    { name: "Other", value: "other" },
    { name: "Unknown", value: "unknown" },
    { name: "No Data", value: "null" },
  ];

  const culvertType = [
    { name: "Arch", value: "arch" },
    { name: "Box", value: "box" },
    { name: "Bridge", value: "bridge" },
    { name: "Pipe", value: "pipe" },
    { name: "Pipe Arch", value: "pipe-arch" },
    { name: "Other", value: "other" },
    { name: "Unknown", value: "unknown" },
    { name: "No Data", value: "null" },
  ];

  return {
    initialFilters,
    getDefaultFiltersByDataView,
    spatialFilters,
    filtersThatDisableDataSorts,
    dataSortsDisabledForSpatialSmartFilters,
    dataSortsEnabledForSpatialSmartFilters,
    cleanoutType,
    responsiblePartyOptions,
    liftStationTypes,
    getAllCorrectiveOptions,
    yesNoOptions,
    scenarioPhaseOptions,
    shapeOptionsCleanoutManholes,
    conditionOptions,
    getEnforcementLevel,
    bmpTypeOptionsNoAbbreviationsScenarios,
    cofOptionsWithNull,
    shapeOptions,
    outfallShapeOptions,
    pipeTypeOptions,
    muniImplementationPhaseOptions,
    openChannelType,
    serviceType,
    flowType,
    linedAssetsShapes,
    culvertType,
    sbmpTypes,
    _getAllMaintenanceIssueOptionKeys,
  };
};

module.exports = FilterConstants();
const Tree = require("./tree");
const ToolSettings = require("./settings/toolSettings");
const DateTime = require("./dateTime");
